const VERSION_REGEX =
  /^(?<major>\d+)(\.(?<minor>\d+))?(\.(?<patch>\d+))?(\s*\((?<revision>\d+)\))?$/

interface Version {
  major: number | null
  minor: number | null
  patch: number | null
  revision: number | null
}

const NULL_VERSION: Version = {
  major: null,
  minor: null,
  patch: null,
  revision: null,
}

function versionFromString(s: string): Version {
  const m = s.match(VERSION_REGEX)
  if (!m) return NULL_VERSION

  const major = m.groups?.major ? parseInt(m.groups.major) : null
  const minor = m.groups?.minor ? parseInt(m.groups.minor) : null
  const patch = m.groups?.patch ? parseInt(m.groups.patch) : null
  const revision = m.groups?.revision ? parseInt(m.groups.revision) : null

  return { major, minor, patch, revision }
}

function compare(v1: Version, v2: Version): number {
  for (const k of ['major', 'minor', 'patch', 'revision'] as const) {
    const a = v1[k]
    const b = v2[k]
    if (a != b) {
      if (a == null) return 1
      if (b == null) return -1
      return a - b
    }
  }
  return 0
}

export function compareVersion(s1: string, s2: string): number {
  const version1 = versionFromString(s1)
  const version2 = versionFromString(s2)

  return compare(version1, version2)
}
